import React from "react";
import { ArrowRight } from "lucide-react";

export function ArtifactPreviewCard({ qa, onOpen }) {
  if (!qa) return null;
    const hasPlan =
      qa?.artifact_plan && qa.artifact_plan.artifact_possible === true;
    const hasCharts = Boolean(qa.artifact_image_url);
    const hasReport = Boolean(qa.report_url);
    const planType = hasPlan ? (qa.artifact_plan.artifact_type || "table") : null;
    const planCount = hasPlan
      ? Math.min(
          (qa.artifact_plan.categories || []).length,
          (qa.artifact_plan.series || []).length
        )
      : 0;
  ;

  return (
    <div
      style={{
        background:
          "linear-gradient(90deg, rgba(255, 255, 255, 0.032) 0%, rgba(255, 255, 255, 0.08) 100%)",
        border: "1px solid #FFFFFF1F",
        borderRadius: "12px",
        padding: "1rem",
        margin: "1rem 0",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        transition: "background-color 0.2s ease",
      }}
      onClick={onOpen}
    >
      <div>
        <div
          style={{
            color: "#ffffff",
            fontSize: "1.1rem",
            fontWeight: "600",
            marginBottom: "0.25rem",
            fontStyle: "Regular",
          }}
        >
          {hasPlan
            ? "Visualization Ready"
            : hasCharts && hasReport
            ? "Charts & Report Available"
            : hasCharts
            ? "Chart Available"
            : "Report Available"}
        </div>
        <div
          style={{
            color: "#9ca3af",
            fontSize: "0.875rem",
            fontStyle: "Regular",
          }}
        >
          Artifact • Version 1
        </div>
      </div>
      <div style={{ color: "#ffffff", fontSize: "1.5rem" }}>
        <ArrowRight />
      </div>
    </div>
  );
}
